import { computed, ref, watch } from 'vue';
import { useAuthStore } from '../modules/auth/store';
import { Products } from '../enums';
// import all the permissions available from enum, as well as permission checker from its utilities
import { UserPermission } from '../modules/permission/enum';
import { userCompanyPreference } from '@/composables/CompanyPreferenceComposable';

export function useMenu() {
    const authStore = useAuthStore();
    const {fetchCompanyPreference} = userCompanyPreference()

    const menuItems = [
        // company selection is only for the root users
        {
            // label: 'Selection',
            icon: 'pi pi-fw pi-building',
            items: [{ label: 'Company', icon: 'pi pi-fw pi-building', to: '/company' }],
            visible: authStore.hasPermission(UserPermission.READ_COMPANY) && authStore.isGodUser,
            product: Products.GENERIC,
        },
        {
            items: [{ label: 'Add Debrief', icon: 'pi pi-fw pi-car', to: { name: 'DebriefCreateFast' }, style: 'background-color: #801136' }],
            visible: authStore.hasPermission(UserPermission.WRITE_DEBRIEF),
            product: Products.AMS,
            companyPreference: 'DebriefCreateFast',
        },
        {
            // label: 'Favorites',
            icon: 'pi pi-fw pi-home',
            items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-database', visible: authStore.hasPermission(UserPermission.READ_METRIC) }],
            product: Products.PHA,
        },
        {
            items: [
                {
                    label: 'Manage Forms',
                    icon: 'pi pi-fw pi-check-square',
                    items: [{ label: 'Attributes', icon: 'pi pi-fw pi-bars', to: { name: 'Attribute' }, visible: authStore.hasPermission(UserPermission.READ_GROUP_PERMISSION_USER) }],
                },
            ],
            product: Products.PHA,
        },
        {
            items: [
                { label: 'Home', icon: 'pi pi-fw pi-home', to: { name: 'Home' } },
                {
                    label: 'Tasks',
                    icon: 'pi pi-fw pi-align-left',
                    items: [
                        { label: 'View Tasks', icon: 'pi pi-fw pi-list', to: { name: 'Tasks' }, visible: authStore.hasPermission(UserPermission.READ_TASK) },
                        { label: 'Add New Task', icon: 'pi pi-fw pi-plus', to: { name: 'TaskForm' }, visible: authStore.hasPermission(UserPermission.WRITE_TASK) },
                        { label: 'Draft', icon: 'pi pi-fw pi-folder-open', to: { name: 'DraftTasks' }, visible: authStore.hasPermission(UserPermission.READ_TASK) },
                        // { label: 'Archived Tasks', icon: 'pi pi-fw pi-save', to: '/archivedTask', visible: false },
                        // { label: 'Deleted Tasks', icon: 'pi pi-fw pi-trash', to: '/button', class: '', visible: false },
                    ],
                },
                {
                    label: 'Report',
                    icon: 'pi pi-fw pi-file',
                    items: [
                        { label: 'Task Report', icon: 'pi pi-fw pi-list', to: { name: 'TaskReports' } },
                        { label: 'Debrief Report', icon: 'pi pi-fw pi-list', to: { name: 'DebriefReports' }, visible: authStore.hasPermission(UserPermission.READ_DEBRIEF_REPORT) },
                    ],
                },
                {
                    label: 'Incident',
                    icon: 'pi pi-fw pi-bell',
                    visible: authStore.hasPermission(UserPermission.GLOBAL_TASK_FORCE) || authStore.isGodUser,
                    items: [
                        { label: 'View Incidents', icon: 'pi pi-fw pi-list', to: { name: 'Incidents' }, visible: authStore.hasPermission(UserPermission.READ_INCIDENT) },
                        { label: 'Add Incident', icon: 'pi pi-fw pi-plus', to: { name: 'IncidentCreateUpdate' }, visible: authStore.hasPermission(UserPermission.WRITE_INCIDENT) },
                    ],
                },
                {
                    label: 'Debrief',
                    icon: 'pi pi-fw pi-check-square',
                    items: [
                        { label: 'View Debriefs', icon: 'pi pi-fw pi-list', to: { name: 'Debriefs' }, visible: authStore.hasPermission(UserPermission.READ_DEBRIEF) },
                        { label: 'Add Debrief', icon: 'pi pi-fw pi-plus', to: { name: 'DebriefCreateUpdate' }, visible: authStore.hasPermission(UserPermission.WRITE_DEBRIEF) },
                    ],
                },
                {
                    label: 'View Learning Outcomes',
                    icon: 'pi pi-fw pi-building-columns',
                    to: {
                        name: 'LearningOutcomes'
                    },
                    visible: (authStore.hasPermission(UserPermission.GLOBAL_TASK_FORCE) || authStore.isGodUser) && authStore.hasPermission(UserPermission.READ_LEARNING_OUTCOME),
                },
                {
                    label: 'Department',
                    icon: 'pi pi-fw pi-building',
                    items: [{ label: 'Manage Departments', icon: 'pi pi-fw pi-list', to: { name: 'Department' }, visible: authStore.hasPermission(UserPermission.READ_USER_DEPARTMENT) }],
                },
                {
                    label: 'Source',
                    icon: 'pi pi-fw pi-table',
                    items: [{ label: 'Manage Sources', icon: 'pi pi-fw pi-list', to: { name: 'Source' }, visible: authStore.hasPermission(UserPermission.READ_SOURCE) }],
                },
                {
                    label: 'Themes',
                    icon: 'pi pi-fw pi-th-large',
                    items: [{ label: 'Manage Themes', icon: 'pi pi-fw pi-list', to: { name: 'Theme' }, visible: authStore.hasPermission(UserPermission.READ_THEME) }],
                },
                {
                    label: 'Appliances',
                    icon: 'pi pi-fw pi-code',
                    items: [{ label: 'Manage Appliances', icon: 'pi pi-fw pi-list', to: { name: 'Appliance' }, visible: authStore.hasPermission(UserPermission.READ_CALLSIGN) }],
                },
                {
                    label: 'Checklist',
                    icon: 'pi pi-fw pi-list',
                    items: [{ label: 'Manage Checklist', icon: 'pi pi-fw pi-list', to: { name: 'Checklist' }, visible: authStore.hasPermission(UserPermission.READ_CHECKLIST) },
                        { label: 'Station', icon: 'pi pi-building', to: { name: 'station' }, visible: authStore.hasPermission(UserPermission.READ_STATION) }],
                },
            ],
            product: Products.AMS,
        },
        {
            items: [
                {
                    label: 'Users',
                    icon: 'pi pi-fw pi-users',
                    items: [{ label: 'Manage Users', icon: 'pi pi-fw pi-list', to: { name: 'Users' }, visible: authStore.hasPermission(UserPermission.READ_USERS) }],
                },
                {
                    label: 'Settings',
                    icon: 'pi pi-fw pi-cog',
                    items: [
                        { label: 'License', icon: 'pi pi-fw pi-credit-card', to: { name: 'License' }, visible: authStore.isGodUser },
                        { label: 'Permission', icon: 'pi pi-fw pi-key', to: { name: 'Permission' }, visible: authStore.isGodUser },
                        { label: 'Manage Groups', icon: 'pi pi-fw pi-list', to: { name: 'Groups' }, visible: authStore.hasPermission(UserPermission.READ_GROUP_PERMISSION_USER) },
                        { label: 'Manage Group Membership', icon: 'pi pi-fw pi-users', to: { name: 'GroupMembership' }, visible: authStore.hasPermission(UserPermission.READ_GROUP_PERMISSION_USER) },
                    ],
                    visible: authStore.isGodUser || authStore.hasPermission(UserPermission.READ_GROUP_PERMISSION_USER),
                },
                { label: 'Help', icon: 'pi pi-fw pi-question', url: "https://ignis.freshdesk.com/support/home", target:"_blank", style: 'background-color: rgb(24,108,185'  },
            ],
            product: Products.GENERIC,
        },
    ];

    const company_id = computed(() => {
        return authStore.getLoggedUserCompanyId;
    });

    watch(company_id, () => {
        menuSetup()
    });

    const filteredMenuItems = ref([])

    function menuSetup() {
        if (typeof company_id.value !== 'undefined' && company_id.value > 0) {
            fetchCompanyPreference(company_id.value).then((companyPreferences) => {

                filteredMenuItems.value = menuItems?.filter((menuItem) => {
                    let companyPreferenceAllowed = true

                    if (typeof menuItem.companyPreference !== 'undefined') {
                        if (typeof companyPreferences !== 'undefined' && Object.hasOwn(companyPreferences, 'DebriefCreateFast')) {
                            companyPreferenceAllowed = companyPreferences.DebriefCreateFast === 1
                        }
                    }
                    return (menuItem.product === Products.GENERIC || menuItem.product === authStore.selectedProduct) && companyPreferenceAllowed
                });
            })
        }
    }

    menuSetup()

    return {
        filteredMenuItems,
    };
}
